import React from 'react';
import permissionDenied from '../../../../assets/img/Errors/permission-denied.png';
import './forbidden-page.scss';

import ErrorPage from '../../../../components/error-pages/error'

// for permission errors
const ForbiddenPage = () => {
    const title = "Triyo - Forbidden";
    const className = "forbidden-page";
    const image = <img className="forbidden-picture" src={permissionDenied} alt={"Forbidden Access"} />
    const info = <p className="forbidden-info">Sorry, you don't have permission to use this feature. <br></br> Please contact your Department Administrator for assistance.</p>

    return (
        <ErrorPage 
            className={className}
            title={title}
            image={image}
            info={info}
        />
    )
}

export default ForbiddenPage;